export const AppConstants = {
  appId: '651e5f278c257a598376a36b',
  OPTIONAL_SITE_VISIT: 'OPTIONAL',
  MANDATORY_SITE_VISIT: 'MANDATORY'
}
